import { ChevronDown } from 'lucide-react';

import { cn } from '@/lib/utils';

type SettingsSectionHeaderProps = {
  label: string;
  required?: boolean;
  value?: string;
  count?: number;
  isOpen: boolean;
  disabled?: boolean;
  onClick: () => void;
};

export const SettingsSectionHeader = ({
  label,
  required,
  value,
  count,
  isOpen,
  disabled,
  onClick,
}: SettingsSectionHeaderProps) => {
  return (
    <button
      type="button"
      disabled={disabled}
      className={cn(
        'flex h-9 w-full items-center gap-2 px-3 text-sm font-semibold text-slate-500',
        'disabled:cursor-not-allowed disabled:text-slate-400'
      )}
      onClick={onClick}
    >
      <span className="min-w-0 shrink-0 text-left">
        {label}
        {required ? <span aria-hidden>*</span> : null}
      </span>
      {required ? <span className="sr-only">required</span> : null}
      {value ? (
        <span className="min-w-0 flex-1 truncate text-left text-xs font-semibold text-primary-light">
          {value}
        </span>
      ) : count ? (
        <span className="flex min-w-6 flex-1 justify-start">
          <span className="flex size-6 items-center justify-center rounded-full bg-primary-light/10 text-xs font-semibold text-primary-light">
            {count}
          </span>
        </span>
      ) : (
        <span className="flex-1" />
      )}
      <ChevronDown
        aria-hidden
        className={cn('size-4 shrink-0 transition-transform duration-200', isOpen && 'rotate-180')}
      />
    </button>
  );
};
